import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Diet } from "../models/diet.model";

export namespace DietActions {

  @logDispatcher
  export class GetDiets {
    static readonly type = '[Diet] GetDiets';
    constructor() {}
  }

  @logDispatcher
  export class GetDietsSuccess {
    static readonly type = '[Diet] GetDietsSuccess';
    constructor(public diets: Diet[]) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Diet] Error';
    constructor(public error: any) {}
  }
}
